import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';

const Tabbings = ({ console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, accessedPermission, tab_imp_exp, tab_air_sea }) => {

    // Define tab mapping (eventKey -> URL path)    
    const navigate = useNavigate();
    const location = useLocation();
    const tabRoutes = {
        job_order: job_order_url,
        direct_mawb: direct_master_url,
        console_hawb: console_house_url,
        console_mawb: console_master_url,
        console_manifest: console_manifest_url,
    };

    // Determine active tab from current URL
    const getActiveTab = () => {
        const foundKey = Object.keys(tabRoutes).find(key => location.pathname === tabRoutes[key]);
        return foundKey || "job_order"; // Default tab if not found
    };

    const [activeTab, setActiveTab] = useState(getActiveTab());

    // Update tab when location changes
    useEffect(() => {
        setActiveTab(getActiveTab());
    }, [location.pathname]);


    return (
        <>
            <div className="row-gap-2">
                <div className="tab-content" id="pills-tabContent">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => {
                            setActiveTab(k);
                            navigate(tabRoutes[k]); // Navigate to the corresponding route
                        }}
                        transition={false}
                        id="noanim-tab-example"
                        className="nav nav-pills mb-3 custom-tabs gap-0"
                    >
                        {
                            (
                                (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_air_import_list")) ||
                                (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_air_export_list")) ||
                                (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_sea_import_list")) ||
                                (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_sea_export_list"))
                            ) &&
                            <Tab eventKey="job_order" title="Job Order" className="nav-item" />}
                        {
                            (
                                (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_ai_direct_shipment_list")) ||
                                (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_ae_direct_shipment_list")) ||
                                (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_si_direct_shipment_list")) ||
                                (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_se_direct_shipment_list"))
                            ) &&
                            <Tab eventKey="direct_mawb" title={`Direct Shipment M${tab_air_sea == "air" ? "AWB" : "BL"}`} className="nav-item" />}
                        {(
                            (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_ai_console_shipment_hawb_list")) ||
                            (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_ae_console_shipment_hawb_list")) ||
                            (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_si_console_shipment_hbl_list")) ||
                            (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_se_console_shipment_hbl_list"))
                        ) &&
                            <Tab eventKey="console_hawb" title={`Console Shipment H${tab_air_sea == "air" ? "AWB" : "BL"}`} className="nav-item" />}
                        {(
                            (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_ai_console_shipment_mawb_list")) ||
                            (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_ae_console_shipment_mawb_list")) ||
                            (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_si_console_shipment_mbl_list")) ||
                            (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_se_console_shipment_mbl_list"))
                        ) &&
                            <Tab eventKey="console_mawb" title={`Console Shipment M${tab_air_sea == "air" ? "AWB" : "BL"}`} className="nav-item" />}
                        {(
                            (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_ai_console_manifest_list")) ||
                            (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_ae_console_manifest_list")) ||
                            (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_si_console_manifest_list")) ||
                            (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_se_console_manifest_list"))
                        ) &&
                            <Tab eventKey="console_manifest" title="Console Manifest" className="nav-item" />}
                    </Tabs>
                </div>
            </div>
        </>
    )
}

export default Tabbings